<template>
  <div class="top_nav">
    <div class="nav_menu">
      <div class="nav toggle">
        <a id="menu_toggle" @click="menuToggle"><i class="fa fa-bars"></i></a>
      </div>
      <nav class="nav navbar-nav">
        <ul class=" navbar-right">
          <li class="nav-item dropdown open" style="padding-left: 15px;">
            <a id="navbarDropdown"
               aria-expanded="false"
               aria-haspopup="true"
               class="user-profile dropdown-toggle"
               data-toggle="dropdown"
               href="javascript:">
              <img alt="" :src="userInfo ? userInfo.image_profile || '/images/user.png' : '/images/user.png'">{{
                userInfo ? userInfo.fullname || 'Guest' : 'Guest'
              }}
            </a>
            <div aria-labelledby="navbarDropdown" class="dropdown-menu dropdown-usermenu pull-right">
              <!--              <a class="dropdown-item" href="javascript:;"> Profile</a>-->
              <!--              <a class="dropdown-item" href="javascript:;">-->
              <!--                <span class="badge bg-red pull-right">50%</span>-->
              <!--                <span>Settings</span>-->
              <!--              </a>-->
              <!--              <a class="dropdown-item" href="javascript:;">Help</a>-->
              <router-link to="/sign-out" tag="a" class="dropdown-item">
                <i class="fa fa-sign-out pull-right"></i> Đăng xuất
              </router-link>
            </div>
          </li>

          <!--          <li class="nav-item dropdown open" role="presentation">-->
          <!--            <a id="navbarDropdown1" aria-expanded="false" class="dropdown-toggle info-number" data-toggle="dropdown" href="javascript:;">-->
          <!--              <i class="far fa-envelope"></i>-->
          <!--              <span class="badge bg-green">6</span>-->
          <!--            </a>-->
          <!--            <ul aria-labelledby="navbarDropdown1" class="dropdown-menu list-unstyled msg_list" role="menu">-->
          <!--              <li class="nav-item">-->
          <!--                <a class="dropdown-item">-->
          <!--                  <span class="image"><img alt="Profile Image" src="/images/img.jpg"/></span>-->
          <!--                  <span>-->
          <!--                    <span>John Smith</span>-->
          <!--                    <span class="time">3 mins ago</span>-->
          <!--                  </span>-->
          <!--                  <span class="message">-->
          <!--                    Film festivals used to be do-or-die moments for movie makers. They were where...-->
          <!--                  </span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li class="nav-item">-->
          <!--                <a class="dropdown-item">-->
          <!--                  <span class="image"><img alt="Profile Image" src="/images/img.jpg"/></span>-->
          <!--                  <span>-->
          <!--                    <span>John Smith</span>-->
          <!--                    <span class="time">3 mins ago</span>-->
          <!--                  </span>-->
          <!--                  <span class="message">-->
          <!--                    Film festivals used to be do-or-die moments for movie makers. They were where...-->
          <!--                  </span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li class="nav-item">-->
          <!--                <a class="dropdown-item">-->
          <!--                  <span class="image"><img alt="Profile Image" src="/images/img.jpg"/></span>-->
          <!--                  <span>-->
          <!--                    <span>John Smith</span>-->
          <!--                    <span class="time">3 mins ago</span>-->
          <!--                  </span>-->
          <!--                  <span class="message">-->
          <!--                    Film festivals used to be do-or-die moments for movie makers. They were where...-->
          <!--                  </span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li class="nav-item">-->
          <!--                <a class="dropdown-item">-->
          <!--                  <span class="image"><img alt="Profile Image" src="/images/img.jpg"/></span>-->
          <!--                  <span>-->
          <!--                    <span>John Smith</span>-->
          <!--                    <span class="time">3 mins ago</span>-->
          <!--                  </span>-->
          <!--                  <span class="message">-->
          <!--                    Film festivals used to be do-or-die moments for movie makers. They were where...-->
          <!--                  </span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li class="nav-item">-->
          <!--                <div class="text-center">-->
          <!--                  <a class="dropdown-item">-->
          <!--                    <strong>See All Alerts</strong>&nbsp;-->
          <!--                    <i class="far fa-angle-right"></i>-->
          <!--                  </a>-->
          <!--                </div>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopNav",
  props: {
    userInfo: Object
  },
  methods: {
    menuToggle() {
      let $BODY = $('body');
      let $SIDEBAR_MENU = $('#sidebar-menu');
      if ($BODY.hasClass('nav-md')) {
        $SIDEBAR_MENU.find('li.active ul').hide();
        $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
      } else {
        $SIDEBAR_MENU.find('li.active-sm ul').show();
        $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
      }

      $BODY.toggleClass('nav-md nav-sm');

      // $('.dataTable').each(function () { $(this).dataTable().fnDraw(); });
    }
  }
}
</script>

<style scoped>

</style>